import { render, staticRenderFns } from "./OrderPackets.vue?vue&type=template&id=8b2a654a&scoped=true&"
import script from "./OrderPackets.vue?vue&type=script&lang=js&"
export * from "./OrderPackets.vue?vue&type=script&lang=js&"
import style0 from "./OrderPackets.vue?vue&type=style&index=0&id=8b2a654a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2a654a",
  null
  
)

export default component.exports